/**
 * 用户管理列表查询参数
 */
export interface UserMngListParams {
  /** 用户 ID 列表 */
  userNumbers?: string[];
  /** 用户名 */
  name?: string;
  /** 邮箱 */
  email?: string;
  /** 当前页码，默认 1 */
  currentPage?: number;
  /** 每页数量，默认 20 */
  pageSize?: number;
  /** 用户状态 */
  userStatus?: UserStatus;
  /** 注册时间开始，格式 yyyy-MM-dd */
  createTimeStart?: string;
  /** 注册时间结束，格式 yyyy-MM-dd */
  createTimeEnd?: string;
  /** 最近操作人名字 */
  updateUser?: string;
  /** 推荐人 Supp ID */
  invitorUserSuppId?: string;
  /** 推荐人名字 */
  invitorName?: string;
  /** 是否有邀请 */
  hasInvite?: boolean;
  /** 是否有校园认证 */
  hasCampus?: boolean;
  /** 学校 ID */
  campusId?: string;
  /** 是否通过艺术家认证 */
  certificated?: boolean;
  /** 新手任务是否完成 */
  taskCompleted?: boolean;
}

/**
 * 用户状态枚举
 */
export enum UserStatus {
  /** 未激活 */
  UNKNOWN = 0, // 未激活
  /** 正常 */
  ACTIVE = 1, // 正常
  /** 封禁中 */
  BANNED = 2, // 封禁中
  /** 警告中 */
  ALERT = 3, // 警告中
  /** 已注销 */
  CANCEL = 4, // 已注销
  /** 冻结中 */
  FROZEN = 5, // 冻结中
}

/**
 * 用户管理列表项
 */
export interface UserMngItem {
  /** 用户 ID */
  userId: string;
  /** Supp ID */
  userNumber: number;
  /** 用户名 */
  name: string;
  /** 用户状态 */
  userStatus: UserStatus;
  /** 是否订阅 */
  subscriptionStatus: number;
  /** 状态描述 */
  userStatusDesc: string;
  /** 注册时间 */
  createTime: string;
  /** 最近操作人 */
  updateUser: string;
  /** 是否是艺术家 */
  isArtist: boolean;
  /** 认证学校 */
  campusName: string;
  /** 推荐人 */
  invitorName: string;
  /** 邀请人数 */
  inviteUserNum: number;
  /** 作品数 */
  artworkNum: number;
  /** 新手任务是否完成 */
  isTaskFinished: boolean;
  /** 设备类型 */
  deviceType?: number;
  /** appsflyer渠道来源 */
  afSource?: string;
  /** appsflyer归因数据 */
  afCampaign?: string;
  enableLimit: number;
}

/**
 * 性别枚举
 */
export enum Gender {
  /** 其他 */
  OTHER = 0,
  /** 男 */
  MALE = 1,
  /** 女 */
  FEMALE = 2,
}

/**
 * 用户详细信息
 */
export interface UserDetail extends UserMngItem {
  /** 头像 URL */
  headImageUrl: string;
  /** 作品总数 */
  artworkTotalNum: number;
  /** 关注数 */
  followNum: number;
  /** 点赞和收藏数 */
  likeAndCollectionNum: number;
  /** 作品审核驳回数 */
  artworkReviewRejectNum: number;
  /** 电子邮箱 */
  email: string;
  /** 生日 */
  birthday: string;
  /** 性别 */
  gender: Gender;
}

/**
 * 用户管理列表响应
 */
export interface UserMngListResponse {
  /** 总数 */
  total: number;
  /** 当前页码 */
  currentPage: number;
  /** 每页数量 */
  pageSize: number;
  /** 列表项 */
  records: UserMngItem[];
}

/**
 * 用户管理批量封禁参数
 */
export interface UserMngBatchBanParams {
  /** 用户 ID 列表 */
  userIds: string;
  /** 封禁原因 */
  forbiddenDesc: string;
}

/**
 * 用户管理历史记录项
 */
export interface UserMngHistoryItem {
  /** 操作人 */
  adminName: string;
  /** 操作用户描述 */
  operateUserDesc: string;
  /** 操作原因 */
  operateReason: string;
  /** 操作时间 */
  createTime: string;
  /** 警告过期时间 */
  warnExpireDate?: string;
}

/**
 * 用户管理历史记录响应
 */
export interface UserMngHistoryResponse {
  /** 总数 */
  total: number;
  /** 当前页码 */
  currentPage: number;
  /** 每页数量 */
  pageSize: number;
  /** 列表项 */
  records: UserMngHistoryItem[];
}

/**
 * 用户管理历史记录查询参数
 */
export interface UserMngHistoryParams {
  /** 用户 ID */
  userId: string;
  /** 当前页码 */
  currentPage: number;
  /** 每页数量 */
  pageSize: number;
}
